import { render, staticRenderFns } from "./SubmittedDialog.vue?vue&type=template&id=5a0c4fbf&scoped=true&"
import script from "./SubmittedDialog.vue?vue&type=script&lang=js&"
export * from "./SubmittedDialog.vue?vue&type=script&lang=js&"
import style0 from "./SubmittedDialog.vue?vue&type=style&index=0&id=5a0c4fbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0c4fbf",
  null
  
)

export default component.exports